/*=========================================================================================
  File Name: moduleDeviceActions.js
  Description: Device Module Actions
==========================================================================================*/

import kpiGql from "@/http/requests/cbs/kpi_gql";
import deviceGql from "@/http/requests/cbs/device_gql";
import categoryGql from "@/http/requests/cbs/category_gql";
import accessoryGql from "@/http/requests/cbs/accessory_gql";
import inventoryGql from "@/http/requests/cbs/inventory_gql";
import riceInventoryGql from "@/http/requests/rice/inventory_gql";
import todoListGql from "@/http/requests/cbs/todo_list_gql";
import requestV2GQL from "@/http/requests/request/request_v2_gql.js";

import constant from "../../utils/constant";

export default {
	setDevicesSearchQuery({ commit }, query) {
		commit("SET_DEVICES_SEARCH_QUERY", query);
	},

	fetchDevices({ commit }, payload) {
		return new Promise((resolve, reject) => {
			deviceGql
				.fetchDevices(payload)
				.then(response => {
					commit("SET_DEVICES", response.devices);
					commit("SET_IS_FETCHED_DEVICES", true);
					commit("SET_TOTAL_DEVICES", response.totalDevices);
					commit("SET_DEVICES_STATUS", response.devicesStatus);
					resolve(response);
				})
				.catch(error => {
					commit("SET_IS_FETCHED_DEVICES", false);
					reject(error);
				});
		});
	},

	addDevice({ state, commit }, device) {
		return new Promise((resolve, reject) => {
			deviceGql
				.addDevice(device)
				.then(response => {
					// commit(
					// 	"ADD_DEVICE",
					// 	Object.assign(device, { id: response.id })
					// );
					commit("SET_TOTAL_DEVICES", state.totalDevices + 1);

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateDevice({ commit }, device) {
		return new Promise((resolve, reject) => {
			deviceGql
				.updateDevice(device)
				.then(response => {
					commit("UPDATE_DEVICE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteDevice({ state, commit }, deviceId) {
		return new Promise((resolve, reject) => {
			deviceGql
				.deleteDevice(deviceId)
				.then(response => {
					commit("DELETE_DEVICE", deviceId);
					commit("SET_TOTAL_DEVICES", state.totalDevices - 1);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	getDevice({ commit }, code) {
		return new Promise((resolve, reject) => {
			deviceGql
				.getDevice(code)
				.then(response => {
					commit("UPDATE_DEVICE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchKpiDetails({ commit }, payload) {
		return new Promise((resolve, reject) => {
			kpiGql
				.getKpi(payload)
				.then(response => {
					commit("SET_KPI_DETAILS", response.kpi);
					commit("SET_TOTAL_KPI_DETAILS", response.total);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addKpiv2ToObject({ commit }, kpiDetail) {
		return new Promise((resolve, reject) => {
			kpiGql
				.addKpiv2ToObject(kpiDetail)
				.then(response => {
					commit("ADD_KPI_DETAIL", response);
					commit("INCREASE_TOTAL_KPI_DETAIL");
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateKpiv2ToObject({ commit }, kpiDetail) {
		return new Promise((resolve, reject) => {
			kpiGql
				.updateKpiv2ToObject(kpiDetail)
				.then(response => {
					commit("UPDATE_KPI_DETAIL", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteKpiDetail({ commit }, kpiDetailId) {
		return new Promise((resolve, reject) => {
			kpiGql
				.deleteKpiDetail(kpiDetailId)
				.then(response => {
					commit("DELETE_KPI_DETAIL", kpiDetailId);
					commit("REDUCTION_TOTAL_KPI_DETAILS");
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchCategories({ commit }, payload) {
		return new Promise((resolve, reject) => {
			categoryGql
				.fetchCategories(payload)
				.then(response => {
					commit("SET_CATEGORIES", response.categories);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addCategory({ commit }, category) {
		return new Promise((resolve, reject) => {
			categoryGql
				.addCategory(category)
				.then(response => {
					commit("ADD_CATEGORY", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateCategory({ commit }, category) {
		return new Promise((resolve, reject) => {
			categoryGql
				.updateCategory(category)
				.then(response => {
					commit("UPDATE_CATEGORY", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteCategory({ commit }, categoryId) {
		return new Promise((resolve, reject) => {
			categoryGql
				.deleteCategory(categoryId)
				.then(response => {
					commit("DELETE_CATEGORY", categoryId);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchInventories({ commit }, payload) {
		return new Promise((resolve, reject) => {
			riceInventoryGql
				.fetchInventories(payload)
				.then(response => {
					commit("SET_INVENTORIES", response.inventories);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addInventory({ commit }, inventory) {
		return new Promise((resolve, reject) => {
			inventoryGql
				.addInventory(inventory)
				.then(response => {
					commit("ADD_INVENTORY", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateInventory({ commit }, inventory) {
		return new Promise((resolve, reject) => {
			inventoryGql
				.updateInventory(inventory)
				.then(response => {
					commit("UPDATE_INVENTORY", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteInventory({ commit }, inventoryId) {
		return new Promise((resolve, reject) => {
			inventoryGql
				.deleteInventory(inventoryId)
				.then(response => {
					commit("DELETE_INVENTORY", inventoryId);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchAccessories({ commit }, payload) {
		return new Promise((resolve, reject) => {
			accessoryGql
				.fetchAccessories(payload)
				.then(response => {
					if (payload.type_id === constant.ACCESSORY_TYPE.ACCESSORY) {
						commit("SET_ACCESSORIES", response.accessories);
						commit("SET_TOTAL_ACCESSORIES", response.total);
					} else if (payload.type_id === constant.ACCESSORY_TYPE.MATERIAL) {
						commit("SET_MATERIAL", response.accessories);
						commit("SET_TOTAL_MATERIAL", response.total);
					}
					resolve(response);
				})
				.catch(error => {
					commit("SET_ACCESSORIES", []);
					reject(error);
				});
		});
	},

	addAccessory({ commit }, accessory) {
		return new Promise((resolve, reject) => {
			accessoryGql
				.addAccessory(accessory)
				.then(response => {
					if (accessory.type_id === constant.ACCESSORY_TYPE.ACCESSORY) {
						commit("ADD_ACCESSORY", response);
						commit("INCREASE_TOTAL_ACCESSORIES");
					} else if (accessory.type_id === constant.ACCESSORY_TYPE.MATERIAL) {
						commit("ADD_MATERIAL", response);
						commit("INCREASE_TOTAL_MATERIAL");
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateAccessory({ commit }, accessory) {
		return new Promise((resolve, reject) => {
			accessoryGql
				.updateAccessory(accessory)
				.then(response => {
					if (accessory.type_id === constant.ACCESSORY_TYPE.ACCESSORY) {
						commit("UPDATE_ACCESSORY", response);
					} else if (accessory.type_id === constant.ACCESSORY_TYPE.MATERIAL) {
						commit("UPDATE_MATERIAL", response);
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteAccessory({ commit }, accessory) {
		return new Promise((resolve, reject) => {
			accessoryGql
				.deleteAccessory(accessory.id)
				.then(response => {
					if (accessory.type_id === constant.ACCESSORY_TYPE.ACCESSORY) {
						commit("DELETE_ACCESSORY", accessory.id);
						setTimeout(() => {
							commit("REDUCTION_TOTAL_ACCESSORIES");
						}, 400);
					} else if (accessory.type_id === constant.ACCESSORY_TYPE.MATERIAL) {
						commit("DELETE_MATERIAL", accessory.id);
						setTimeout(() => {
							commit("REDUCTION_TOTAL_MATERIAL");
						}, 400);
					}

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	resetDataAccessories({ commit }) {
		commit("RESET_ACCESSORIES");
	},

	fetchKpisV2({ commit }, payload) {
		return new Promise((resolve, reject) => {
			categoryGql
				.fetchKpisV2(payload)
				.then(response => {
					commit("SET_KPI_V2", response.kpisv2);
					commit("SET_TOTAL_KPI", response.total);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	cloneKpisToDevice({ commit }, payload) {
		return new Promise((resolve, reject) => {
			deviceGql
				.cloneKpisToDevice(payload)
				.then(response => {
					commit("UPDATE_DEVICE", response.device);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	createKpiv2({ commit }, payload) {
		return new Promise((resolve, reject) => {
			kpiGql
				.createKpiv2(payload)
				.then(response => {
					commit("ADD_KPI", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getLogsDeviceTodo({ state, commit }, payload) {
		return new Promise((resolve, reject) => {
			todoListGql
				.fetchTodoByRelations(payload)
				.then(response => {
					if (payload.logsType === constant.LOGS_DEVICE_TODO_TYPE.CURRENT) {
						commit("SET_LOGS_CURRENT_TODO", [...state.logsCurrentTodo, ...response.todoList]);
						commit("SET_TOTAL_LOGS_CURRENT_TODO", response.totalTodoList);
					} else if (payload.logsType === constant.LOGS_DEVICE_TODO_TYPE.DONE) {
						commit("SET_LOGS_DONE_TODO", [...state.logsDoneTodo, ...response.todoList]);
						commit("SET_TOTAL_LOGS_DONE_TODO", response.totalTodoList);
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	resetDataLogsTodo({ commit }) {
		commit("SET_LOGS_CURRENT_TODO", []);
		commit("SET_LOGS_DONE_TODO", []);
		commit("SET_TOTAL_LOGS_CURRENT_TODO", 0);
		commit("SET_TOTAL_LOGS_DONE_TODO", 0);
	},
	getLogsRequestByDevice({ state, commit }, payload) {
		return new Promise((resolve, reject) => {
			requestV2GQL
				.getRequestsByRelations(payload)
				.then(response => {
					commit("SET_LOGS_REQUEST_BY_DEVICE", [...state.requestsByDevice, ...response.requests]);
					commit("SET_TOTAL_LOGS_REQUEST_BY_DEVICE", response.total);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	resetDataLogsRequest({ commit }) {
		commit("SET_LOGS_REQUEST_BY_DEVICE", []);
		commit("SET_TOTAL_LOGS_REQUEST_BY_DEVICE", 0);
	},
	resetDataKpiDetails({ commit }) {
		commit("SET_TOTAL_KPI_DETAILS", 0);
		commit("SET_KPI_DETAILS", []);
	}
};
